<template>
	<headerSearch></headerSearch>
	<div class="w1440 personal_center">
		<div class="flex-box col90 ptb10 page_location">
			当前位置：
			<router-link class="col04" to="/BaseInfo">
				用户中心
				<span class="plr5">/</span>
			</router-link>
			<router-link class="col04" to="/Order">
				我的订单
				<span class="plr5">/</span>
			</router-link>
			<div class="now_page">订单详情</div>
		</div>
		<div class="flex-box flex-col-start">
			<personal-nav :firstIndex="1" :secondIndex="-1"></personal-nav>
			<div class="ml10 flex-grow-1 part_r">
				<div class="bgf part1">
					<div class="flex-box flex-between">
						<div class="fs18 col04 fwb">订单详情</div>
						<!-- <div class="back col12 cursor flex-box" @click="$router.go(-1)">返回</div> -->
					</div>
					<div v-if="orderInfo.address" class="box send_box mt25 mb25">
						<div class="title_box flex-box col27 fwb">
							<div class="flex-grow-1">收件人信息</div>
							<!-- <div class="fs18 col12 underline">修改地址</div> -->
							<div @click="onExpress(orderInfo.order_sn)" v-if="orderInfo.btns && orderInfo.btns.includes('express')" class="col12 log flex-box underline cursor">查看物流</div>
						</div>
						<div class="detail_box">
							<!-- <div class="flex-box shop fs20 col12 fwb mb15">***医疗美容机构</div> -->
							<div class="flex-box col27 fwb mb10">
								<div>{{ orderInfo.address.province_name + "-" + orderInfo.address.city_name + "-" + orderInfo.address.district_name }}{{ orderInfo.address.address }}</div>
								<!-- <div class="default  colf">默认</div> -->
							</div>
							<div class="fs27">{{ orderInfo.address.consignee }} {{ orderInfo.address.mobile }}</div>
						</div>
					</div>
					<div class="flex-box flex-between mb15">
						<div class="col04">订单编号：{{ orderInfo.order_sn }}</div>
						<div class="col12">{{ orderInfo.status_code == "nosend" && (orderInfo.check_status == "checked" || orderInfo.check_status == "failed") ? orderInfo.check_status_text : orderInfo.status_text }}</div>
					</div>
					<div class="box info_box mb25">
						<div class="title_box flex-box col04 tc">
							<div class="box1">商品</div>
							<!-- <div class="box2">规格</div> -->
							<div class="box3">单价(元)</div>
							<div class="box4">数量</div>
							<div class="flex-grow-1 tc">小计(元)</div>
						</div>
						<div v-for="item in orderInfo.items" :key="item.id" @click="goodsDetail(item)" class="goods_box flex-box">
							<div class="box1 flex-box">
								<img :src="item.goods_image" class="pic" alt="" />
								<div class="flex-grow-1 pl30">
									<!-- <span class=" colf">特价</span>3件装 |  -->
									{{ item.goods_title }}
								</div>
							</div>
							<!-- <div class="box2 tc">3支/盒</div> -->
							<div class="box3 tc col90">{{ item.goods_price }}</div>
							<div class="box4 tc col27">× {{ item.goods_num }}</div>
							<div class="flex-grow-1 tc coleb">{{ item.goods_price * item.goods_num }}</div>
						</div>
						<div v-if="orderInfo.btns && orderInfo.btns.includes('pay')" class="tc tips coleb">
							{{ orderInfo.ext.countdown_text }}
						</div>
						<div v-if="orderInfo.status_code == 'cancel'" class="tc cancel col12 mt15">{{ formatDatetime(orderInfo.ext.cancel_time, "yyyy-mm-dd hh:ii") }} 已取消订单</div>
					</div>
					<div class="col90 mb15">订单总金额：{{ orderInfo.order_amount }}</div>
					<div class="col90 mb15" v-if="orderInfo.score_fee > 0">积分抵扣金额：{{ orderInfo.score_fee }}</div>
					<div class="col90 mb15">实际支付金额：{{ orderInfo.pay_fee }}</div>
					<div class="flex-box flex-between mb15">
						<div class="col90">创建时间：{{ orderInfo.createtime_text }}</div>
						<!-- <div v-if="orderInfo.pay_types_text.length > 0" class=" col04">支付方式：<span v-for="(payType, index) in orderInfo.pay_types_text" :key="index" class="col12">{{ payType }}</span></div> -->
					</div>
					<div v-if="orderInfo.pay_types_text.length > 0" class="col90 mb15">
						支付方式：
						<span v-for="(payType, index) in orderInfo.pay_types_text" :key="index" class="col12">{{ payType }}</span>
						<span @click="dialogVisible = true" class="cursor" v-if="orderInfo.pay_certificate">(查看凭证)</span>
					</div>
					<div v-if="orderInfo.status_code == 'noget'" class="col90 mb15">发货时间：{{ formatDatetime(orderInfo.ext.send_time, "yyyy-mm-dd hh:ii") }}</div>
					<div v-if="orderInfo.status_code == 'completed'" class="col90 mb15">收货时间：{{ formatDatetime(orderInfo.ext.confirm_time, "yyyy-mm-dd hh:ii") }}</div>
					<div class="flex-box flex-end mt25">
						<div class="foot_btn resend flex-box flex-center fs20 fwb" @click="onReport(orderInfo)" v-if="orderInfo.btns && orderInfo.btns.includes('re_report')">重新上传试用报告</div>
						<div class="foot_btn sure fs20 fwb" @click="onReport(orderInfo)" v-if="orderInfo.btns && orderInfo.btns.includes('report')">上传试用报告</div>
						<div @click="onConfirm(orderInfo)" v-if="orderInfo.btns && orderInfo.btns.includes('confirm')" class="foot_btn sure fs20 fwb">确认收货</div>
						<div @click="toggleCancel(orderInfo.id)" v-if="orderInfo.btns && orderInfo.btns.includes('cancel')" class="foot_btn fs20 fwb">取消订单</div>
						<div @click.stop="openPopup(index)" v-if="orderInfo.btns && orderInfo.btns.includes('pay')" class="foot_btn sure fs20 fwb">立即付款</div>
						<div v-if="(orderInfo.activity_type != 'groupon' || orderInfo.items[0].ladder_status == 0) && (orderInfo.btns.includes('apply_refund') || orderInfo.btns.includes('re_apply_refund'))" @click.stop="onRefund(orderInfo.id, orderInfo.items, orderInfo.status_code)" class="foot_btn sure fwb">申请退款</div>
					</div>
				</div>
				<div class="bgf part2 mt10" v-if="orderInfo.report">
					<div class="fs18 col04 fwb">我的试用报告</div>
					<div class="flex-box zip_box">
						<img src="../../../assets/static/icon/report_icon.png" alt="" />
            <div class="flex-grow-1">{{orderInfo.report.file_name}}</div>
            <div class="cold3">{{orderInfo.report.file_size}}M</div>
            <a :href="orderInfo.report.report_file" class="col12 ml40">下载</a>
            <a href="javascript:;" class="col12 ml40" @click="reportDel(orderInfo)">删除</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<el-dialog v-model="dialogVisible" width="40%" center padding="0" :style="{ padding: '0' }" :show-close="false">
		<img :src="orderInfo.pay_certificate.certificate" alt="" style="width: auto; height: 80vh; display: block; margin: 0 auto" />
	</el-dialog>
	<popup :visible="cancelPop" @close="cancelPop = false">
		<div class="cancel_pop">
			<div class="content">
				<img src="../../../assets/static/icon/c_order_close.png" class="order_close" alt="" @click="cancelPop = false" />
				<div class="fs24 col3 fwb tc">订单取消</div>
				<div class="pl10">
					<div class="tips coleb flex-box">取消后无法恢复，请谨慎选择。</div>
					<div class="colb mb30">请选择取消订单原因</div>
					<div v-for="(item, index) in cancelReasonList" :key="index" @click="onChange(index)" class="flex-box reason col3" :class="reasonIndex == index ? 'active' : ''">{{ item.content }}</div>
				</div>
				<div class="flex-box flex-between btn_box fwb">
					<div class="btn1 col3d" @click="cancelConfirm()">确定取消</div>
					<div class="btn2 colf" @click="cancelPop = false">暂不取消</div>
				</div>
			</div>
		</div>
	</popup>
	<popup :visible="orderPopStatus" @close="orderPopStatus = false">
		<div class="pop2 p20">
			<div class="fs20 tc title fwb">支付方式</div>
			<div @click="changeOrderPayment(index)" class="flex flex-box mt25" v-for="(pay, index) in payTypeList2" :key="index">
				<img :src="pay.icon" class="ico20 cursor" alt="" />
				<div class="flex-grow-1 fs18 ml10">
					{{ pay.name }}
				</div>
				<img @click="onActivityCheck" v-if="payIndex2 == index" src="../../../assets/static/icon/jj_radio_sc.png" class="ico20 cursor" alt="" />
				<img @click="onActivityCheck" v-else src="../../../assets/static/icon/jj_radio_uc.png" class="ico20 cursor" alt="" />
			</div>
			<div class="btn_confirm2 fs16 colf tc mt20 cursor" @click="onOrderPay()">确认付款</div>
		</div>
	</popup>
</template>

<script>
	import PersonalNav from "../../../components/PersonalNav.vue";
	import { useHead } from "@unhead/vue";
	import { onMounted } from "vue";
	export default {
		setup() {
			onMounted(() => {
				useHead({
					title: "订单详情--小狮优选",
					meta: [
						{ name: "description", content: "This is my page description" },
						{ property: "og:title", content: "My Page Title" },
						{ property: "og:description", content: "This is my page description" },
						{ property: "og:url", content: "https://example.com/my-page" },
						{ property: "og:image", content: "https://example.com/my-image.jpg" },
					],
					link: [{ rel: "canonical", href: "https://example.com/my-page" }],
				});
			});
		},
		components: {
			PersonalNav,
		},
		data() {
			return {
				reasonIndex: 0,
				reasonType: 1,
				showStart: false,
				cancelReasonList: [
					{
						id: 1,
						content: "不想要了",
					},
					//{id:2,content:"拍错地址"},
					{
						id: 3,
						content: "拍错产品",
					},
				],
				cancelPop: false,
				type: 0, //0普通订单 1新品体验 2万件拼团
				state: 0, //0待付款 1待付款-取消订单 2待发货 3待收货 4已完成
				showreport: false,

				orderSn: "",
				orderInfo: {
					pay_types_text: [],
					items: [],
					btns: [],
				},
				payIndex2: 0,
				payTypeList2: [
					{ id: "wechat", name: "微信支付", icon: require("../../../assets/static/images/jxr_pay_icon3.png") },
					{ id: "duigong", name: "公对公付款", icon: require("../../../assets/static/images/jxr_pay_icon2.png") },
				],
				orderPopStatus: false,
				chooseOrder: null,
				payMulti: false,
				dialogVisible: false,
			};
		},
		computed: {
			islogin() {
				return this.$h.islogin();
			},
		},
		created() {
			const orderSn = this.$route.query.orderSn;
			if (orderSn) {
				this.orderSn = orderSn;
			} else {
				this.$message.error("未接收到有效的订单编号");
			}
			if (!this.islogin) {
				this.$router.push("/Login");
			} else {
				this.fetchOrderDetail();
			}
		},
		methods: {
			//单个订单立即支付
			openPopup(index) {
				// this.chooseOrder = this.orderList[index];
				this.payMulti = false;
				this.orderPopStatus = true;
			},
			changeOrderPayment(index) {
				this.payIndex2 = index;
			},
			cancelConfirm() {
				let reason = this.cancelReasonList[this.reasonIndex].content;
				this.onCancel({
					reason,
				});
			},
			async onCancel(e) {
				let orderId = this.orderInfo.id;
				this.$api
					.OrderCacncel({
						id: orderId,
						reason: e.reason,
					})
					.then((ret) => {
						this.cancelPop = false;
						this.$message({
							customClass: "custom-message",
							message: "取消成功",
							type: "success",
						});
						this.fetchOrderDetail();
					});
			},
			onChange(index) {
				this.reasonIndex = index;
				this.reasonType = this.cancelReasonList[index].id;
			},
			//取消订单
			toggleCancel(orderId) {
				this.orderId = orderId;
				this.cancelPop = true;
			},
			formatDatetime(date, fmt) {
				//author: meizz
				if (!date) {
					return "";
				}
				if (!(date instanceof Date)) {
					if (/^\d+$/.test(date)) {
						date = (date + "").length > 10 ? date : date * 1000;
						date = new Date(parseInt(date));
					} else {
						date = new Date(date.replace(/-/g, "/"));
					}
				}
				var o = {
					"m+": date.getMonth() + 1, //月份
					"d+": date.getDate(), //日
					"h+": date.getHours(), //小时
					"i+": date.getMinutes(), //分
					"s+": date.getSeconds(), //秒
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度
					S: date.getMilliseconds(), //毫秒
				};
				var yearMatch = fmt.match(/(y+)/);
				if (yearMatch) {
					fmt = fmt.replace(yearMatch[0], (date.getFullYear() + "").substr(4 - yearMatch[0].length));
				}
				for (var k in o) {
					var match = fmt.match(new RegExp("(" + k + ")"));
					if (match) fmt = fmt.replace(match[0], match[0].length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
				}
				return fmt;
			},
			fetchOrderDetail() {
				let that = this;
				this.$api
					.OrderDetail({
						id: this.orderSn,
					})
					.then((res) => {
						this.orderInfo = res.data;
						let n = this.orderInfo;
						if (n.btns.includes("pay") && n.ext.expired_in >= 0) {
							n.ext.countdown_text = that.$h.timeFormat(n.ext.expired_in);
							n.ext.it = setInterval(() => {
								n.ext.expired_in--;
								n.ext.countdown_text = that.$h.timeFormat(n.ext.expired_in);
								if (n.ext.expired_in <= 0) {
									clearInterval(n.ext.it);
									that.fetchOrderDetail();
								}
							}, 1000);
						}
					});
			},
			//申请售后
			bindRefund(aftersale) {
				uni.navigateTo({
					url: "/pages/RequestRefund/RequestRefund?order_id=" + aftersale.order_id + "&item_ids=" + aftersale.id,
					events: {
						refundSuccess: (data) => {
							this.fetchOrderDetail();
						},
					},
				});
			},
			//商品详情
			goodsDetail(goods) {
				let query = { id: goods.goods_id };
				if (goods.activity_id && goods.activity_id > 0) {
					query.activity_id = goods.activity_id;
				}
				console.log(query);
				const targetPath = this.$router.resolve({ path: "/FindProductDetail", query: query }).href;
				// 在新窗口中打开目标页面
				window.open(targetPath, "_blank");
			},
			//售后详情
			bindRefundInfo(id) {
				uni.navigateTo({
					url: "/pages/RefundDetail/RefundDetail?id=" + id,
				});
			},
			onRefund(orderId, items, status_code) {
				let item_ids = [];
				items.forEach((item) => {
					item_ids.push(item.id);
				});
				this.refundData = {
					order_id: orderId,
					item_ids: item_ids.join(","),
					refund_from: "order",
				};
				if (status_code == "nosend") {
					let query = this.refundData;
					query.expressIndex = 0;
					this.$router.push({
						path: "/Refund",
						query: query,
					});
				} else {
					this.refundPop = true;
				}
			},
			//物流
			onExpress(orderId) {
				this.$router.push({ path: "/LogDetail", query: { id: orderId } });
			},
			// 确认收货
			async onConfirm(order, ignore = false) {
				// 需开启确认收货组件
				let page = this;
				this.$confirm("确定要收货？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.OrderConfirm({ id: order.id }).then((ret) => {
						page.fetchOrderDetail();
					});
				});
			},
			//上传报告
			onReport(order) {
				this.$router.push({ path: "/SendReport", query: { order_sn: order.order_sn } });
			},
			reportDel(order){
				let page = this;
				this.$confirm("确定要删除报告？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				}).then(() => {
					page.$api.ReportDel({ order_sn: order.order_sn, report_id: order.report.id}).then((ret) => {
						page.fetchOrderDetail();
					});
				});
			},
			onOrderPay() {
				let payment = this.payTypeList2[this.payIndex2].id;
				let orderSn = [this.orderInfo.order_sn];

				if (orderSn.length <= 0) {
					uni.showToast({
						title: "请选择待付款订单",
						icon: "error",
					});
					return;
				}
				let data = JSON.stringify({
					orderSN: orderSn.join(","),
					payment: payment,
					payState: "paying",
					orderType: "goods",
					//buyType: this.orderPayload.buy_type || ''
				});
				if (payment == "wechat") {
					//微信扫码支付
					this.$router.push({ path: "/Checkout", query: { data: encodeURIComponent(data) } });
				} else {
					//对公支付
					this.$router.push({ path: "/Corporate", query: { data: encodeURIComponent(data) } });
				}
				this.orderPopStatus = false;
			},
		},
	};
</script>

<style lang="less" scoped>
	.order_close {
		width: 16px;
		height: 16px;
		position: absolute;
		top: 23px;
		right: 27px;
		cursor: pointer;
	}

	.cancel_pop {
		width: 566px;
		border-radius: 24px;
		border: 6px solid rgba(255, 255, 255, 0.4);

		.content {
			height: 100%;
			width: 100%;
			background-color: #fff;
			border-radius: 19px;
			position: relative;
			padding: 64px 30px 61px;

			.tips {
				height: 32px;
				background: rgba(235, 63, 37, 0.06);
				border-radius: 4px;
				margin: 26px 0 22px;

				&::before {
					content: "";
					display: block;
					background: url("../../../assets/static/icon/c_wait.png") no-repeat center;
					background-size: 100%;
					width: 14px;
					height: 14px;
					margin: 0 7px 0 9px;
				}
			}

			.reason {
				margin-bottom: 41px;
				cursor: pointer;

				&::after {
					content: "";
					display: block;
					width: 22px;
					height: 22px;
					background: url("../../../assets/static/icon/c_check2.png") no-repeat center;
					background-size: 100%;
					margin-left: auto;
				}

				&.active::after {
					background-image: url("../../../assets/static/icon/c_check2-on.png");
				}
			}

			.btn_box {
				div {
					width: 245px;
					height: 60px;
					border-radius: 8px;
					border: 1px solid #3d7efe;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}

				.btn2 {
					background: #3d7efe;
				}
			}
		}
	}

	.back::before {
		content: "";
		display: block;
		width: 18px;
		height: 18px;
		background: url("/src/assets/static/icon/c_back.png") no-repeat center;
		background-size: 100%;
		margin-right: 10px;
	}

	.log::after {
		content: "";
		display: block;
		width: 15px;
		height: 15px;
		background: url("/src/assets/static/icon/c_continue.png") no-repeat center;
		background-size: 100%;
		margin-left: 6px;
	}

	.part_r {
		.part1,
		.part2 {
			padding: 41px 44px;
		}
		.zip_box {
			height: 88px;
			background: #fbfcfd;
			border-radius: 8px;
			margin-top: 15px;
      padding: 0 40px;
			img {
				width: 32px;
				height: 32px;
        display: block;
        margin-right: 15px;
			}
		}

		.send_box {
			background: #fbfcfd;

			.title_box {
				height: 71px;
				border-bottom: 1px solid rgba(98, 134, 171, 0.4);
				padding-left: 24px;
				padding-right: 44px;

				&::before {
					content: "";
					display: block;
					width: 17px;
					height: 20px;
					margin-right: 14px;
					background: url("../../../assets/static/icon/c_send.png") no-repeat center;
					background-size: 100%;
				}
			}

			.detail_box {
				padding: 22px 100px 24px 55px;

				.shop {
					position: relative;

					&::before {
						content: "";
						display: block;
						width: 16px;
						height: 14px;
						background: url("../../../assets/static/icon/c_send_shop.png") no-repeat center;
						background-size: 100%;
						position: absolute;
						top: 10px;
						left: -31px;
					}
				}

				.default {
					margin-left: 14px;
					width: 43px;
					height: 20px;
					line-height: 20px;
					text-align: center;
					background: linear-gradient(117deg, #3d6cfe 0%, #4ac3fc 100%);
					border-radius: 4px;
					border: 1px solid;
					border-image: linear-gradient(196deg, rgba(255, 255, 255, 1), rgba(18, 117, 255, 0)) 1 1;
				}
			}
		}

		.info_box {
			border: 1px solid rgba(98, 134, 171, 0.3);

			.title_box {
				width: 100%;
				height: 50px;
				background: #fafcff;
			}

			.goods_box {
				width: 100%;
				margin: 10px 0;

				& ~ .goods_box {
					margin-top: 15px;
				}
			}

			.box1 {
				width: 473px;

				.pic {
					width: 100px;
					height: 100px;
					background: #ffffff;
					border-radius: 8px;
					border: 1px solid rgba(98, 134, 171, 0.2);
					margin-left: 44px;
				}

				span {
					width: 43px;
					height: 20px;
					background: linear-gradient(153deg, #ff4d4d 0%, #ff652d 100%);
					border-radius: 5px;
					display: inline-block;
					line-height: 20px;
					text-align: center;
					margin-right: 10px;
				}
			}

			.box2 {
				width: 156px;
			}

			.box3 {
				width: 100px;
			}

			.box4 {
				width: 120px;
			}

			.tips {
				// width: 1000px;
				line-height: 48px;
				background: rgba(235, 63, 37, 0.06);
				border-radius: 4px;
				text-align: center;
			}

			.cancel {
				width: 1000px;
				height: 48px;
				line-height: 48px;
				background: #fbfcfd;
				border-radius: 4px;
				text-align: center;
			}
		}

		.foot_btn {
			width: 228px;
			height: 60px;
			border-radius: 6px;
			border: 2px solid #d2d2d2;
			color: #434343;
			line-height: 56px;
			text-align: center;
			margin-left: 24px;
			cursor: pointer;

			&.sure {
				background: #1275ff;
				border-color: #1275ff;
				border-radius: 6px;
				color: #fff;
			}
			&.resend {
				color: #1275ff;
				&::before {
					content: "";
					display: block;
					width: 20.5px;
					height: 23px;
					background: url("../../../assets/static/icon/c_resend.png") no-repeat center;
					background-size: 100%;
					margin-right: 6px;
				}
			}
		}
	}

	.pop2 {
		width: 410px;
		border-radius: 10px;
		background: #fff;

		.title {
			width: 100%;
			display: block;
		}

		.pay_icon {
			widows: 20px;
			height: auto;
			display: block;
		}

		.ico20 {
			width: 20px;
			height: auto;
			display: block;
		}

		.btn_confirm2 {
			display: block;
			width: 370px;
			text-align: center;
			height: 50px;
			line-height: 50px;
			background: #3d7efe;
			border-radius: 8px;
		}
	}

	.ico20 {
		width: 20px;
		height: auto;
		display: block;
	}

	.btn22 {
		width: 140px;
		text-align: center;
		height: 44px;
		line-height: 44px;
		background: #1275ff;
		border-radius: 20px;
	}
</style>
